import React from "react";
import {
  FaChartLine,
  FaChartPie,
  FaClock,
  FaSortAmountDown,
  FaStar,
  FaLayerGroup,
} from "react-icons/fa";
import { TbTransitionTopFilled } from "react-icons/tb";
import AnimatedDisplay from "../AnimatedDisplay";
const defaultIcons = {
  "Total Sub-Causes": <FaLayerGroup size={25} color="#4F46E5" />,
  "Total Duration": <FaClock size={25} color="#e44649" />,
  "Top Sub-Cause": <FaStar size={25} color="#f59e0b" />,
  "Monthly Avg": <FaChartPie size={25} color="#0ea5e9" />,
  "Top (Sort Applied)": <FaSortAmountDown size={25} color="#16a34a" />,
  "Current Month Total": <TbTransitionTopFilled size={25} color="#9647adff" />,
};

const KpiCardForGraphs = ({ items = [] }) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
        gap: "16px",
        marginBottom: "30px",
      }}
    >
      {items.map((item, index) => (
        <div
          key={index}
          style={{
            background: "#fff",
            borderRadius: "14px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            padding: "18px 14px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            transition: "transform 0.2s",
            cursor: "pointer",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.03)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          {/* Icon Section */}
          <div
            style={{
              fontSize: "30px",
              color: "#fff",
              // backgroundColor: item.color || "#4a90e2",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            {item.icon ||
              defaultIcons[item.iconType] ||
              defaultIcons[item.title] || <FaChartLine />}
          </div>

          {/* Text Content */}
          <div style={{ lineHeight: 1.3 }}>
            <div style={{ fontSize: "14px", color: "#777" }}>{item.title}</div>

            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: "#333",
                marginTop: "2px",
                height: "20px",
              }}
            >
              <AnimatedDisplay value={item.value} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default KpiCardForGraphs;
